// TODO: find out why jest complains on React.Component, React.lazy, etc.
import React, { lazy, Suspense } from 'react';
import { MYSQL } from '@/util/enums/EnumDbType';
import ForeignKeyRenderer from '@/util/ForeignKeyRenderer';
import CrossJoinRenderer from '@/util/CrossJoinRenderer';
import {
  type TJoinMode,
  SUGGESTED,
  TABLES,
  SAVED_QUERIES,
  selectJoinMode,
  changeMode,
} from '@/features/joinModal/joinModalSlice';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { ALL, EARLIEST, LATEST } from '@/util/enums/EnumIncludeType';
import { useSelector } from 'react-redux';
import { getDatasourceTablesWithCreatedAt } from '@/store-selectors';
import { checkForCreatedAt } from '@/components/modals/ModalJoin/helpers';
import { JoinSuggested, JoinTable, JoinTypeDropdown } from './subcomponents';
import type { JoinModeProps } from './types';

const JoinSavedQuery = lazy(() => import('./subcomponents/JoinSavedQuery'));

const JOIN_MODE_TO_COMPONENT_MAP: Record<TJoinMode, React.FC<JoinModeProps>> = {
  [SUGGESTED]: JoinSuggested,
  [TABLES]: JoinTable,
  [SAVED_QUERIES]: JoinSavedQuery,
};

export type ModalJoinProps = JoinModeProps & {
  dbType: string; // TODO: infer a proper sum/union type e.g. 'postgres' | 'mysql' | ...
};

export const ModalJoin: React.FC<ModalJoinProps> = ({
  state,
  columns,
  userInteraction,
  usedAliases,
  existingViews,
  dbType,
}) => {
  const joinMode = useAppSelector(selectJoinMode);
  const dispatch = useAppDispatch();
  const tablesWithCreatedAt = useSelector(getDatasourceTablesWithCreatedAt);
  const JoinModeComponent = JOIN_MODE_TO_COMPONENT_MAP[joinMode];

  const fkSelected = (props: any) => {
    if (
      !checkForCreatedAt(props.fk, tablesWithCreatedAt) &&
      [LATEST, EARLIEST].includes(state.includeType)
    ) {
      // sort by created_at not supported, so reset
      userInteraction({ section: 'includeType', newValue: ALL })(undefined);
    }
    return userInteraction(props);
  };

  const renderer =
    state.joinType === 'cross'
      ? new CrossJoinRenderer(userInteraction)
      : new ForeignKeyRenderer(fkSelected, usedAliases);

  const handleSwitchToJoinTables = () => {
    if (joinMode === SUGGESTED) {
      dispatch(changeMode(TABLES));
    }
  };

  return (
    <Suspense fallback={<div />}>
      <JoinModeComponent
        state={state}
        columns={columns}
        userInteraction={userInteraction}
        existingViews={existingViews}
        usedAliases={usedAliases}
        renderer={renderer}
      >
        {(state.selected || [TABLES, SAVED_QUERIES].includes(joinMode)) && (
          <JoinTypeDropdown
            state={state}
            userInteraction={userInteraction}
            outerJoinSupported={dbType !== MYSQL}
            onSwitchToJoinTables={handleSwitchToJoinTables}
          />
        )}
      </JoinModeComponent>
    </Suspense>
  );
};
